import type { FC, SVGProps } from "react";

const IconFlexibility: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M15 1L19 5L15 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 10V9C1 7.93913 1.42143 6.92172 2.17157 6.17157C2.92172 5.42143 3.93913 5 5 5H19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 21L1 17L5 13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 12V13C19 14.0609 18.5786 15.0783 17.8284 15.8284C17.0783 16.5786 16.0609 17 15 17H1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconFlexibility;
